export const questionsOrder = [
  'intro', 'location', 'term', 'area', 'budget',
  'mortgage', 'name', 'email', 'phone'
]

export const questions = {
  intro: {
    type: 'button',
    text: [
      'Здравствуйте! Меня зовут Владимир, я ваш личный виртуальный риэлтор. :house_with_garden:',
      'Я буду рад вам помочь приобрести квартиру, которая подойдет именно вам. Начнем?',
      'Нажмите кнопку “давай сделаем это” :point_down:'
    ],
    answers: ['ok']
  },
  location: {
    type: 'multiple',
    text: [
      'Отлично! Я задам вам несколько вопросов, это позволит мне подобрать самый лучший вариант.',
      'В моей базе только проверенные жилые комплексы Москвы и Московской области от ведущих застройщиков. :construction_worker:',
      'Выберите район(округ) или несколько, где бы вы хотели приобрести недвижимость.'
    ],
    answers: [
      'central-district',
      'north-distrcit',
      'north-east-district',
      'east-district',
      'south-east-distrcit',
      'south-distrcit',
      'south-west-distrcit',
      'west-district',
      'north-west-distrcit',
      'zelenogradskiy-distrcit',
      'novomoskovskiy-distrcit'
    ]
  },
  term: {
    type: 'button',
    text: [
      'Отличный выбор. :thumbsup:',
      'Когда вы планируете приобрести квартиру?'
    ],
    answers: [
      'now',
      'term1-3',
      'term3-6',
      'term6-12',
      'term12-p'
    ]
  },
  budget: {
    type: 'button',
    text: [
      'Прекрасно!',
      'На какую стоимость вы рассчитываете?'
    ],
    answers: [
      'budget2',
      'budget2-5',
      'budget5-7',
      'budget7-10',
      'budget10-15',
      'budget15-25',
      'budget25-50',
      'budget50-100',
      'budget100-p'
    ]
  },
  mortgage: {
    type: 'button',
    text: [
      'Выглядит как квартира моей мечты! :gift_heart:',
      'Нужна ли вам дополнительно ипотека?'
    ],
    answers: [
      'yes',
      'no'
    ]
  },
  area: {
    type: 'multiple',
    text: [
      'Хорошо.',
      'Сколько комнат должно быть в вашей будущей квартире? :key:',
      'Выберите один или несколько вариантов. Цена больше зависит от площади и планировки, чем от количества комнат.'
    ],
    answers: [
      'studio',
      'room1',
      'room2',
      'room3',
      'room4',
      'room5'
    ]
  },
  name: {
    type: 'input',
    format: 'text',
    placeholder: 'Ваше имя',
    text: [
      'С вами приятно работать! :pray:',
      'Еще пара вопросов для уточнения контактной информации.',
      'Как я могу к вам обращаться?'
    ]
  },
  email: {
    type: 'input',
    format: 'email',
    placeholder: 'Ваш e-mail',
    text: ({name}) => ([
      `Приятно познакомиться, ${name}! :handshake:`,
      'Укажите вашу электронную почту.'
    ])
  },
  phone: {
    type: 'input',
    format: 'tel',
    text: ({name}) => ([`${name}, по какому телефону с вами можно связаться?`])
  }
}



// WEBPACK FOOTER //
// ./selectors/data/questions.js